<!--  -->
<template>
  <div>
    <el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign">
      <el-form-item label="标签组">
        <el-select v-model="formLabelAlign.group_tag_id" placeholder="请选择" @change="select_type_main">
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.tag_group_name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="公众号">
        <el-checkbox-group v-model="type">
          <el-checkbox label="美食/餐厅线上活动" name="type"></el-checkbox>
          <el-checkbox label="地推活动" name="type"></el-checkbox>
          <el-checkbox label="线下主题活动" name="type"></el-checkbox>
          <el-checkbox label="单纯品牌曝光" name="type"></el-checkbox>
        </el-checkbox-group>
      </el-form-item> -->
      <el-form-item label="公众号">
        <el-tag v-for="items,index in formLabelAlign.app_ids" :key="index" style="margin-right:10px" closable @close="handleCloseacc(items.app_id,index)">{{ items.account_name }} </el-tag>
        <el-button type="warning" size="mini" :disabled="formLabelAlign.error_log_type_main === null" @click="chorwer">选择公众号</el-button>
      </el-form-item>
      <el-form-item>
        <!-- <el-button type="primary" @click="quedwr">确定</el-button> -->
        <el-button type="primary" @click="sumbit">确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="选择公众号"
      :visible.sync="dialogVisibler"
      width="50%"
      :append-to-body="true"
    >
      <bandaccount ref="bandstaffview" @bandarrview="bandarrview" />
    </el-dialog>
  </div>
</template>

<script>
// import { createerroralarm, updateerroralarm } from '@/api/sourceMaterial.js'
import { listForOfficialTags, listForOfficialAccount, officialAccountTags } from '@/api/sourceMaterial.js'
import bandaccount from './bandaccount.vue'
export default {
  components: {
    bandaccount
  },
  data() {
    return {
      input: '',
      sendtype: null,
      labelPosition: 'right',
      formLabelAlign: {
        chat_id: null,
        group_tag_id: null,
        app_ids: []
      },
      app_ids: [],
      options: [],
      chatname: '',
      dialogVisible: false,
      ids: null,
      type: [],
      listData: [],
      pageIfon: {
        page: 1,
        pageSize: 10,
        officialAccount: null
      },
      dialogVisibler: false
    }
  },
  created() {
    this.OfficialTagslist()
    // this.OfficialAccountlist()
  },
  mounted() {

  },
  methods: {
    select_type_main(val) {
      console.log(val)
      this.formLabelAlign.app_ids = []
    },
    async OfficialTagslist() {
      const data = await listForOfficialTags()
      this.options = data.data.list
      // this.total = data.data.total
      console.log('options', data.data.list)
    },
    async OfficialAccountlist() {
      const data = await listForOfficialAccount(this.pageIfon)
      this.listData = data.data.list
      // this.total = data.data.total
      console.log('OfficialAccountlist', data.data.list)
    },
    chorwer() {
      this.dialogVisibler = true
      this.$nextTick(() => {
        this.$refs.bandstaffview.sendr(this.formLabelAlign.app_ids, this.formLabelAlign.group_tag_id)
      })
    },
    handleCloseacc(id, index) {
      console.log(index)
      this.formLabelAlign.app_ids.splice(index, 1)
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.bandaccountview.set(id)
      }, 100)
    },
    bandarrview(arr) {
      console.log('222', arr)
      this.dialogVisibler = false
      this.formLabelAlign.app_ids = arr
    },
    async sumbit() {
      if (this.formLabelAlign.group_tag_id === null) {
        this.$message.error('请选择标签组')
        return
      }

      if (this.formLabelAlign.app_ids.length === 0) {
        this.$message.error('请选择公众号')
        return
      }

      this.app_ids = []
      this.app_ids = this.formLabelAlign.app_ids.map((item) => {
        return item.app_id
      })
      console.log('app_ids', this.app_ids)
      const data = await officialAccountTags({
        group_tag_id: this.formLabelAlign.group_tag_id,
        app_ids: this.app_ids
      })
      console.log('data', data)
      this.$message({
        message: '新增成功',
        type: 'success'
      })
      this.$emit('updata')
    }

  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
